import Burger from "./Burger";
import Logo from "./Logo";
import LanguageSwitcher from "./LanguageSwitcher";
import NavList from "./NavList";
import BaseButton from "../ui/BaseButton";
import BaseContainer from "../ui/BaseContainer/BaseContainer";

import classes from "./Navigation.module.scss";
import { useCallback, useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const Navigation = () => {
  const { t } = useTranslation();

  const [isOpen, setOpen] = useState(false);
  const [prevScroll, setPrevScroll] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const handleMenuToggle = () => {
    setOpen((open) => !open);
  };

  const handleMenuClose = () => {
    setOpen(false);
  };

  const handleScroll = useCallback(() => {
    const currentScrollPos = window.scrollY;

    const isVisible = prevScroll > currentScrollPos;

    setPrevScroll(currentScrollPos);
    setIsVisible(isVisible);
  }, [prevScroll]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <BaseContainer
      className={clsx(classes.navigation, { [classes.show]: isVisible, [classes.open]: isOpen })}
      element="nav"
    >
      <Logo />
      <NavList isOpen={isOpen} onClose={handleMenuClose} />
      <LanguageSwitcher />
      <Burger className={classes["navigation-burger"]} onClick={handleMenuToggle} />
      <HashLink smooth to="/main#contacts" component={BaseButton} className={classes["navigation__order-btn"]}>
        {t("navigation.submit")}
      </HashLink>
    </BaseContainer>
  );
};

export default Navigation;
